import React from "react";
import Button from "@mui/material/Button";
import { Row, Col, Avatar } from 'antd';



const PublicHeader = ({extra}) => {
  return (
      <Row justify={'space-between'} align={'middle'} gutter={16} className={'px-6 py-2'} style={{background: '#1d2024'}} >
          <Col>
              <Row align={'middle'} gutter={32}>
                    <Col>
                        {extra}
                    </Col>

                  <Col>
                      <Row align={'middle'} justify={'start'} gutter={24}>
                          <Col>
                              <Avatar size={'large'} style={{ background: '#668093' }}>
                              IQ
                              </Avatar>
                          </Col>
                          <Col>
                              <Button sx={{color: "#fff", borderColor: '#fff'}} variant={'outlined'}>Learn More</Button>
                          </Col>
                      </Row>
                  </Col>
              </Row>
          </Col>
      </Row>

  );
};

export default PublicHeader;